<div>
    <canvas id="doughNutCanvas" (change)="drawChart($event)"></canvas>
</div>